// extracted by mini-css-extract-plugin
export var circle = "_8y-1";
export var exitConfirmationModal = "_8y-5";
export var iframe = "_8y-0";
export var offline = "_8y-3";
export var online = "_8y-2";
export var workstationSelectError = "_8y-4";